import { render, staticRenderFns } from "./SsoLanding.vue?vue&type=template&id=96293a7e&"
import script from "./SsoLanding.vue?vue&type=script&lang=js&"
export * from "./SsoLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports